export default __webpack_public_path__ + "static/media/Shoe-3.3dfc5d13.mp4";